var React = require('react');

function IconEmail (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0 -81.609)"},React.createElement("g",{"transform":"translate(0 81.609)"},React.createElement("path",{"d":"M19.984,80.609H1.926A1.928,1.928,0,0,0,0,82.535V93.694a1.928,1.928,0,0,0,1.926,1.926H19.984a1.928,1.928,0,0,0,1.926-1.926V82.535A1.928,1.928,0,0,0,19.984,80.609Zm-.251,1.284-.257.214-7.757,6.459a1.194,1.194,0,0,1-1.528,0L2.434,82.107l-.257-.214ZM1.284,82.82,7.6,88.082l-6.32,4.206Zm18.7,11.516H1.926a.643.643,0,0,1-.629-.514l7.336-4.883.736.613a2.478,2.478,0,0,0,3.171,0l.736-.613,7.336,4.882A.643.643,0,0,1,19.984,94.336Zm.642-2.047-6.32-4.206,6.32-5.263Z","transform":"translate(0 -80.609)","fill":"#211e1e"}))));
}

IconEmail.defaultProps = {"width":"21.909","height":"15.01","viewBox":"0 0 21.909 15.01"};

module.exports = IconEmail;

IconEmail.default = IconEmail;
